import React from 'react';

/**
 * Dictionary-style specs block.
 * `specs` is an object: { Label: value, ... }. Falsy values are skipped.
 */
export default function SpecsTable({ title = 'Specifications', specs = {} }) {
  const entries = Object.entries(specs).filter(([, v]) => v !== null && v !== undefined && v !== '');
  if (!entries.length) return null;
  return (
    <div className="mt-8" data-testid="specs-table">
      <h3 className="text-sm font-bold uppercase tracking-widest text-[#334155] mb-3">{title}</h3>
      <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 border-t border-gray-200">
        {entries.map(([k, v]) => (
          <div key={k} className="flex items-baseline justify-between py-2 border-b border-gray-100">
            <dt className="text-sm text-gray-500">{k}</dt>
            <dd className="text-sm font-medium text-gray-900 text-right">{v}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
